import React from 'react';
// import PropTypes from 'prop-types';

// themes: ['day','night','greyscale']

// import data from '../data/vesthimmerland.json';

function createIcon(mapfit, src) {
  const icon = mapfit.Icon();
  icon.setIconUrl(src);
  icon.setWidth(75);
  icon.setHeight(84);
  return icon;
}

class Mapfit extends React.Component {
  constructor(props) {
    super(props);

    this._apiKey = '591dccc4e499ca0001a4c6a41263a49cb8e749f481d9b3f5da1897b6';
    this._mapfit = null;
    this._map = null;

    global._mf = this;

    // TODO: load styles and js library;
    this._loadSDK();
  }

  _loadCSS(href) {
    const element = document.createElement('link');
    element.setAttribute('rel', 'stylesheet');
    element.setAttribute('href', href);
    document.body.appendChild(element);
    return element;
  }

  _loadJS(src) {
    const element = document.createElement('script');
    element.setAttribute('src', src);
    document.body.appendChild(element);
    return element;
  }

  _loadSDK() {
    this._waiting = [true, true, true];
    const tetragon = this._loadJS(
      'https://cdn.mapfit.com/v2-4/assets/js/tetragon.js'
    );
    const mapfit = this._loadJS(
      'https://cdn.mapfit.com/v2-4/assets/js/mapfit.js'
    );
    const styles = this._loadCSS(
      'https://cdn.mapfit.com/v2-4/assets/css/mapfit.css'
    );

    [tetragon, mapfit, styles].forEach((element, key) => {
      element.onload = (...args) => {
        this._waiting[key] = false;
        this._isLoaded();
      };
    });
  }

  _configure() {
    const mapfit = (this._mapfit = global.mapfit);

    mapfit.apikey = this._apiKey;

    const map = (this._map = mapfit.MapView('mapfit', { theme: 'day' }));
    map.setMinZoom(3); // 1-23
    map.setMaxZoom(18);
    map.setZoom(this.props.zoom || 13);

    map.setZoomControlVisibility(true);

    map.setPanEnabled(true);
    map.setPinchEnabled(true);
    map.setScrollWheelEnabled(true);

    const parking = (this._parking = mapfit.Layer());

    this._icons = {
      default: createIcon(
        mapfit,
        'https://cdn.mapfit.com/v2-4/assets/images/markers/pngs/lighttheme/default.png'
      ),
      auto: createIcon(mapfit, 'auto'),
      nature: createIcon(mapfit, 'park'),
      commercial: createIcon(mapfit, 'finance')
    };

    return { mapfit, map, parking };
  }

  _isLoaded() {
    if (this._waiting.filter(Boolean).length || !global.mapfit) {
      return false;
    }

    const { map, mapfit, parking } = this._configure();

    this._getData('vesthimmerland.json');
    this._getData('syddjurs.json');

    // Users current location
    if (this.props.lat && this.props.lng) {
      const position = mapfit.LatLng([this.props.lat, this.props.lng]);
      const marker = mapfit.Marker(position);
      marker.setIcon(this._icons.default);

      map.setCenter(position);
      // map.addMarker(marker);
      map.setRecenterButtonEnabled(true);

      parking.add(marker);
    }

    map.addLayer(parking);
    // map.setCenterWithLayer(parking, 60, 60); // set center with layer and padding
  }

  _getData(file) {
    return fetch(`/data/${file}`)
      .then(response => response.json())
      .then(data => {
        this._attachData(data);
      });
  }

  _attachData(data) {
    const mapfit = this._mapfit;
    const map = this._map;
    const parking = this._parking;

    data.features.forEach(feature => {
      const type = feature.geometry.type;

      if (type === 'Polygon') {
        // let detailPoly = mapfit.Polygon(element);
        let poly = mapfit.Polygon(feature.geometry.coordinates[0]);
        poly.data = feature.properties;
        poly.setStyle({
          color: 'rgba(255, 83, 67, 0.8)',
          fillColor: 'rgba(255, 83, 67, 0.5)'
        });
        poly.on('click', function() {
          // if(lastPoly){
          //     lastPoly.setStyle({color: "#8a94ff", fillColor: "rgba(67, 83, 255, 0.1)"})
          //     lastPoly = this;
          // }else{
          //     lastPoly = this;
          // }
          // selectedDistrict.innerHTML = `<b id="selection">${this.district}</b>`;
          this.setStyle({
            color: 'black',
            fillColor: 'rgba(74, 74, 74, 0.15)'
          });
          // console.log({ bounds: this.getLatLngBounds() }, this.data);
          // currentBounds = this.getLatLngBounds();
          // openMarkers(this.district,detailPoly);
        });

        parking.add(poly);
      } else if (type === 'Point') {
        // const position = mapfit.LatLng(feature.geometry.coordinates);
        const marker = mapfit.Marker(feature.geometry.coordinates);
        // marker.setIcon('auto'); // commercial =finance, park/forest = park

        if (feature.properties.Pplads_type === 'Parkering') {
          marker.setIcon(this._icons.auto);
        } else if (
          feature.properties.Pplads_type === 'Natur parkeringspladser'
        ) {
          marker.setIcon(this._icons.nature);
        }

        const placeInfo = mapfit.PlaceInfo();
        // placeInfo.setTitle('Some title??');
        // placeInfo.setDescription(
        //   '<pre>' + JSON.stringify(feature.properties, null, 2) + '</pre>'
        // );
        placeInfo.enableDirectionsButton();
        marker.setPlaceInfo(placeInfo);

        parking.add(marker);
        // map.addMarker(marker);
      } else {
        console.log('Unknown feature type');
      }

      //add place info to an existing marker
      // const placeInfo = mapfit.PlaceInfo();
      // placeInfo.setTitle("Artichoke Basille's Pizza & Brewery");
      // placeInfo.setDescription(
      //   '<p>111 Macdougal St (btwn Bleeker & W 3rd St)</br>Pizza, Italian</p>'
      // );
      // marker.setPlaceInfo(placeInfo);

      // map.addPolygon(poly);

      // if (cityHoods.includes(element.properties.name.toLowerCase())) {
      //   if (element.properties.name.toLowerCase() == 'chelsea' && !chel) {
      //     chel = true;
      //   } else {
      //     districts.push(element.properties.name);
      //     neighborhoods.push(element.geometry.coordinates[0][0]);
      //   }
      // }
    });

    map.setCenterWithLayer(parking, 60, 60); // set center with layer and padding
  }

  render() {
    return <div id="mapfit" style={{ width: '100%', height: '100%' }} />;
  }
}

export default Mapfit;



// WEBPACK FOOTER //
// ./src/components/Mapfit.js